var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgJo = function SvgJo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-117.82 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(110.46) scale(.9375)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-117.82 0H906.182v170.667H-117.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-117.82 170.667H906.182v170.667H-117.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M-117.82 341.334H906.182v170.667H-117.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117.82 512.001l512.001-256L-117.82 0v512.001z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.528 288.964l5.664-24.82H4.743l22.928-11.045-15.867-19.9 22.93 11.05 5.664-24.82 5.661 24.82 22.93-11.05-15.866 19.9 22.93 11.045H50.602l5.663 24.82-15.867-19.92z"
  })))));
};
export default __webpack_public_path__ + "assets/fbeac94f8e0c612a3c468c6bf13e8f35.svg";
export { SvgJo as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/jo.svg